import { render, staticRenderFns } from "./DashboardShortcuts.vue?vue&type=template&id=159ffd22"
import script from "./DashboardShortcuts.vue?vue&type=script&lang=js"
export * from "./DashboardShortcuts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports